import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { AcademyService } from "../../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../../Report/report-services/group.service";
import { HomeroomService } from "../../../../Report/report-services/homeroom.service";
import { SchoolselectorService } from "../../../../schoolselector/schoolselectorservice.service";
import { DataService_Staff_DigitalID } from "../../shared/data.service";
import { StaffDIDExportRequest } from "../../shared/StaffDIDExportRequest";

@Component({
	selector: "caass-staff-export-digital-id",
	templateUrl: "./staff-export-digital-id.component.html",
	styleUrls: ["./staff-export-digital-id.component.css"],
})
export class StaffExportDigitalIdComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private selectService: SchoolselectorService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private idService: DataService_Staff_DigitalID
	) {}

	ngOnInit(): void {
		this.loadFormatOptions();
		this.loadPersonType();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////

	subscription: any;

	LoadingFormatOptions: boolean = true;
	SelectedFormatOption: any;
	lstFormatOptions: any = [];

	School: any;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingPersonType: boolean = true;
	SelectedPersonType: any;
	lstPersonType: any = [];

	LoadingCourse: boolean = true;
	SelectedCourse: any;
	lstCourse: any = [];

	ActiveOptionID: any = 1;
	lstActiveOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	AlreadyPrintedID: any = -1;
	lstAlreadyPrinted: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Digital ID Printed",
		},
		{
			ID: 0,
			Desc: "Digital ID Not Printed",
		},
	];

	HasEmailOptionID: any = -1;
	lstHasEmailOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Has Email On Record",
		},
		{
			ID: 0,
			Desc: "No Email",
		},
	];

	IsProcessing: boolean = false;

	errorMessage: string = "";

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingFormatOptions = true;

		var result = this.idService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.lstFormatOptions = response;

				this.SelectedFormatOption = this.lstFormatOptions[0];
				this.LoadingFormatOptions = false;
			},
			(error) => {
				this.LoadingFormatOptions = false;
			}
		);
	}

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.idService.StaffTypeSelectList(1); //Include instructor
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.lstPersonType.unshift({
					PersonTypeID: -1,
					PersonTypeDesc: "Any",
				});

				this.SelectedPersonType = this.lstPersonType[0];
				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	loadCourse() {
		this.LoadingCourse = true;

		var result = this.idService.StaffCourseSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstCourse = response;

				this.lstCourse.unshift({
					CourseDesc: "Any",
				});

				this.SelectedCourse = this.lstCourse[0];
				this.LoadingCourse = false;
			},
			(error) => {
				this.LoadingCourse = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////
	onExport() {
		this.IsProcessing = true;

		//
		// Get data from WS
		//

		var parms: StaffDIDExportRequest = {
			SchoolID: this.School.SchoolID,
			PersonTypeID: this.SelectedPersonType.PersonTypeID,
			CourseDesc: this.SelectedCourse.CourseDesc == this.lstCourse[0].CourseDesc ? "" : this.SelectedCourse.CourseDesc,
			HasEmail: this.HasEmailOptionID,
			Active: this.ActiveOptionID,
			AlreadyPrinted: this.AlreadyPrintedID,
			FormatOptionID: this.SelectedFormatOption.ID,
		};

		var result = this.idService.ExportSelectList(parms);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "StaffDigitalID_Export_";

					if (this.School.SchoolID > 0) {
						FileName += this.School.SchoolNumber;
					} else {
						FileName += this.School.SchoolName;
					}

					//Text tab
					if (this.SelectedFormatOption.ID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.SelectedFormatOption.ID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.SelectedFormatOption.ID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////////////////////
	onSchoolChange(school) {
		this.School = school;

		//Load Data
		this.loadCourse();
	}
	///////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingFormatOptions == true || this.LoadingCourse == true || this.LoadingPersonType == true || this.IsProcessing == true;
	}
	///////////////////////////////////////////////////////////////////////////
}
